import { useState, useRef, useEffect } from "react";
import * as api from "./api";
import { Svg, fmt, minsLeft, useWindowWidth, A, OK, OKLt, W, WLt, E, ELt, G,
  iFile, iCheck, iUpload, iX, iTrash, iLink, iText, iLock, iBack, Toast } from "./shared";

// ── 자료 묶음(섹션) — 올댓벤처스 고객 페이지(atv-web/c/collect.js)와 같은 규칙 ──
//  · 항목의 section 으로 묶고, section 없는 항목은 「기본 자료」 한 묶음 (처음 나온 자리 순서 유지)
//  · 묶음이 2개 이상일 때만 탭(모바일) / 좌측 목록(PC ≥1024px) — 1개면 탭 없음
//  · 뱃지 = 제출할 자료 수(미제출+반려), 모두 승인이면 ✓
//  · 처음 열 때는 제출할 자료가 남은 첫 묶음 (?sec= 로 보던 묶음 유지)
const BASE_SEC = "__self__";
function portalItemState(item, uploads) {
  let pend = 0; let app = 0; let rej = 0;
  uploads.forEach(function(u) {
    if (u.itemId !== item.id && u.item_id !== item.id) return;
    if (u.status === "approved") app += 1; else if (u.status === "rejected") rej += 1; else pend += 1;
  });
  if (app > 0 && pend === 0) return "done";
  if (rej > 0 && pend === 0 && app === 0) return "rejected";
  if (pend > 0) return "pending";
  return "need";
}
function buildPortalSections(items, uploads) {
  const list = [];
  const map = {};
  items.forEach(function(it) {
    const key = it.section || BASE_SEC;
    if (!map[key]) { map[key] = { key: key, label: it.section || "기본 자료", total: 0, left: 0, reqLeft: 0, pending: 0, done: 0 }; list.push(map[key]); }
    const sec = map[key];
    const st = portalItemState(it, uploads);
    sec.total += 1;
    if (st === "need" || st === "rejected") { sec.left += 1; if (it.required) sec.reqLeft += 1; }
    else if (st === "pending") sec.pending += 1;
    else sec.done += 1;
  });
  return list;
}
function pickDefaultSection(secs, prev) {
  if (secs.some(function(sc) { return sc.key === prev; })) return prev;
  const firstLeft = secs.find(function(sc) { return sc.left > 0; });
  const pick = firstLeft || secs[0];
  return pick ? pick.key : "";
}

function removeTitleFromName(n){if(!n)return n;return n.replace(/ (대표|부대표|이사|상무|전무|부장|차장|과장|대리|사원|주임|FP|팀장|실장|본부장|센터장|원장|소장|담당|매니저|파트장|직원|스텝|사장|부사장|회장)$/,"");}

export default function PortalScreen({ portalData, loadPortal, setScreen, fromAdmin }) {
  var portalW = useWindowWidth();
  var pMob = portalW < 640;
  var [portalName, setPortalName] = useState("고객");  // 제출자 자동설정 (UI 숨김)
  var [uploading, setUploading] = useState(false);

  var [portalCustom, setPortalCustom] = useState(false);
  var [textInputs, setTextInputs] = useState({});
  var [radioInputs, setRadioInputs] = useState({});
  var [checkInputs, setCheckInputs] = useState({});
  var fileRefs = useRef({});
  var [toast, setToast] = useState("");
  var [actionLoading, setActionLoading] = useState(false);
  const [activeSec, setActiveSec] = useState(function() {
    try { return new URLSearchParams(window.location.search).get("sec") || ""; } catch (e) { return ""; }
  });
  const secTopRef = useRef(null);
  // 데이터가 바뀌면(처음 로드·다시 불러오기) 보던 묶음은 유지, 없으면 제출할 자료가 남은 첫 묶음
  useEffect(function() {
    if (!portalData || !Array.isArray(portalData.items)) return;
    const secs = buildPortalSections(portalData.items, portalData.uploads || []);
    setActiveSec(function(prev) { return pickDefaultSection(secs, prev); });
  }, [portalData]);
  function showToast(msg) { setToast(msg); setTimeout(function(){ setToast(""); }, 3000); }

  // 관리자 승인/반려 기능
  async function doAdminApprove(uploadId) {
    try { setActionLoading(true); await api.approveUpload(uploadId); await loadPortal(d && d.id); showToast("승인 완료"); } catch(e) { showToast("오류: "+e.message); } finally { setActionLoading(false); }
  }
  async function doAdminBatchApprove(ids) {
    try { setActionLoading(true); await api.batchApprove(ids); await loadPortal(d && d.id); showToast(ids.length+"건 승인 완료"); } catch(e) { showToast("오류: "+e.message); } finally { setActionLoading(false); }
  }
  async function doAdminReject(uploadId) {
    var reason = window.prompt("반려 사유를 입력하세요:");
    if (!reason || !reason.trim()) return;
    try { setActionLoading(true); await api.rejectUpload(uploadId, reason); await loadPortal(d && d.id); showToast("반려 완료"); } catch(e) { showToast("오류: "+e.message); } finally { setActionLoading(false); }
  }
  async function doAdminBatchReject(ids) {
    var reason = window.prompt("일괄 반려 사유를 입력하세요:");
    if (!reason || !reason.trim()) return;
    try { setActionLoading(true); await api.batchReject(ids, reason); await loadPortal(d && d.id); showToast(ids.length+"건 반려 완료"); } catch(e) { showToast("오류: "+e.message); } finally { setActionLoading(false); }
  }

  if (!portalData) return <div style={{ padding:40,textAlign:"center",color:G[400] }}>로딩 중...</div>;

  if (portalData._notFound) {
    return (
      <div style={{ minHeight:"100vh",background:G[50],display:"flex",alignItems:"center",justifyContent:"center" }}>
        <div style={{ textAlign:"center",padding:40 }}>
          <div style={{ fontSize:48,marginBottom:16 }}>📋</div>
          <h2 style={{ fontSize:20,fontWeight:700,color:G[800],marginBottom:8 }}>페이지를 찾을 수 없습니다</h2>
          <p style={{ fontSize:14,color:G[500] }}>링크가 만료되었거나 잘못된 주소입니다.</p>
        </div>
      </div>
    );
  }

  var d = portalData;
  var brand = d.branding || { name:"", color:A };
  var themeColor = brand.color || A;
  var items = d.items || [];
  var uploads = d.uploads || [];
  // 통합 포털 대응: 항목/업로드마다 원본 프로젝트로 쓰기 라우팅 (단일 포털이면 d.id로 폴백)
  var projForItem = function(itemId){ var it = items.find(function(x){return x.id===itemId;}); return (it && it.projectId) ? it.projectId : d.id; };
  var projForUpload = function(uploadId){ var u = uploads.find(function(x){return x.id===uploadId;}); return (u && u.projectId) ? u.projectId : d.id; };
  var isClosed = d.status === "closed";

  // 마감 화면
  if (isClosed) {
    return (
      <div style={{ minHeight:"100vh",background:G[50],display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Pretendard',sans-serif" }}>
        <div style={{ textAlign:"center",padding:40 }}>
          {brand.logo && <img src={brand.logo} alt={brand.name||""} style={{ height:brand.brand==="atv"?42:brand.brand==="law"?46:28,maxWidth:brand.brand==="atv"||brand.brand==="law"?"min(200px,56vw)":"min(160px,50vw)",objectFit:"contain",marginBottom:16 }} />}
          <div style={{ width:56,height:56,borderRadius:14,background:"linear-gradient(135deg,#1B3A5C,"+themeColor+")",margin:"0 auto 16px",display:"flex",alignItems:"center",justifyContent:"center" }}><Svg d={iLock} s={26} c="#fff" /></div>
          <h2 style={{ color:G[700],margin:"0 0 8px",fontSize:18 }}>자료 수집이 종료되었습니다</h2>
          <p style={{ color:G[400],fontSize:13 }}>문의사항은 담당자에게 연락해주세요.</p>
        </div>
      </div>
    );
  }

  // 섹션 분류
  var sections = { need:[], pending:[], done:[], rejected:[] };
  items.forEach(function(item) {
    var iu = uploads.filter(function(u){return u.itemId===item.id || u.item_id===item.id;});
    var pend = iu.filter(function(u){return u.status==="pending";});
    var app = iu.filter(function(u){return u.status==="approved";});
    var rej = iu.filter(function(u){return u.status==="rejected";});

    if (app.length > 0 && pend.length === 0) {
      sections.done.push({ item:item, uploads:iu.filter(function(u){return u.status!=="rejected";}) });
    } else if (rej.length > 0 && pend.length === 0 && app.length === 0) {
      sections.rejected.push({ item:item, uploads:iu });
    } else if (pend.length > 0) {
      sections.pending.push({ item:item, uploads:iu });
    } else {
      sections.need.push({ item:item, uploads:iu });
    }
  });

  var allDone = sections.need.length === 0 && sections.pending.length === 0 && sections.rejected.length === 0;

  // 자료 묶음 탭 — 묶음 2개 이상일 때만. 1024px 이상은 좌측 목록, 그 아래는 상단 가로 탭 (올댓벤처스 페이지와 동일)
  const portalSecs = buildPortalSections(items, uploads);
  const curSecKey = pickDefaultSection(portalSecs, activeSec);
  const secMulti = portalSecs.length > 1;
  const secWide = portalW >= 1024;
  function goSection(key) {
    setActiveSec(key);
    try {
      if (window.location.pathname.indexOf("/portal/") === 0) {
        window.history.replaceState(null, "", window.location.pathname + "?sec=" + encodeURIComponent(key));
      }
    } catch (e) { /* 무시 */ }
    // 아래로 내려가 있었다면 묶음 첫머리로
    const top = secTopRef.current ? secTopRef.current.getBoundingClientRect().top + window.scrollY - 8 : 0;
    if (secTopRef.current && window.scrollY > top) {
      try { window.scrollTo({ top: top }); } catch (e) { /* 무시 */ }
    }
  }
  function secBadge(sc, onDark) {
    if (sc.left > 0) {
      return <span aria-label={"제출 필요 " + sc.left + "건"} style={{ flexShrink:0,minWidth:20,height:20,padding:"0 6px",borderRadius:10,boxSizing:"border-box",
        background:onDark?"#fff":E,color:onDark?E:"#fff",fontSize:12,fontWeight:800,display:"inline-flex",alignItems:"center",justifyContent:"center",fontVariantNumeric:"tabular-nums" }}>{sc.left}</span>;
    }
    if (sc.total > 0 && sc.pending === 0) return <span style={{ flexShrink:0,fontSize:13,fontWeight:800,color:onDark?"#BBF7D0":OK }}>✓</span>;
    return null;
  }
  function renderSecTabs() {
    return (
      <div role="tablist" aria-label="자료 묶음 선택" style={{ display:"flex",overflowX:"auto",scrollbarWidth:"none",background:"#fff",
          margin:pMob?"0 -16px 16px":"0 0 18px",borderRadius:pMob?0:10,
          borderTop:pMob?"none":"1px solid "+G[200],borderLeft:pMob?"none":"1px solid "+G[200],borderRight:pMob?"none":"1px solid "+G[200],borderBottom:"1px solid "+G[200] }}>
        {portalSecs.map(function(sc) {
          const on = sc.key === curSecKey;
          return (
            <button key={sc.key} type="button" role="tab" aria-selected={on} onClick={function(){ goSection(sc.key); }}
              style={{ flex:"1 0 auto",minWidth:104,minHeight:50,padding:"0 14px",display:"inline-flex",alignItems:"center",justifyContent:"center",gap:7,
                background:"none",border:"none",borderBottom:"3px solid "+(on?themeColor:"transparent"),marginBottom:-1,cursor:"pointer",
                color:on?themeColor:G[500],fontFamily:"inherit" }}>
              <span style={{ fontSize:15,fontWeight:on?800:700,whiteSpace:"nowrap",letterSpacing:"-0.02em" }}>{sc.label}</span>
              {secBadge(sc, false)}
            </button>
          );
        })}
      </div>
    );
  }
  function renderSecTree() {
    return (
      <nav aria-label="자료 묶음 선택" style={{ flex:"0 0 232px",background:"#fff",border:"1px solid "+G[200],borderRadius:12,padding:"14px 10px" }}>
        <div style={{ padding:"0 8px 8px",fontSize:13,fontWeight:800,color:G[500] }}>자료 묶음 {portalSecs.length}개</div>
        {portalSecs.map(function(sc, si) {
          const on = sc.key === curSecKey;
          return (
            <button key={sc.key} type="button" aria-current={on ? "true" : undefined} onClick={function(){ goSection(sc.key); }}
              style={{ width:"100%",minHeight:46,padding:"0 10px",marginBottom:2,borderRadius:8,border:"none",cursor:"pointer",textAlign:"left",
                display:"flex",alignItems:"center",gap:9,background:on?themeColor+"15":"transparent",fontFamily:"inherit" }}>
              <span style={{ flexShrink:0,width:22,height:22,borderRadius:6,background:on?themeColor:themeColor+"18",color:on?"#fff":themeColor,fontSize:13,fontWeight:800,display:"inline-flex",alignItems:"center",justifyContent:"center" }}>{si+1}</span>
              <span style={{ flex:1,minWidth:0,fontSize:14.5,fontWeight:on?800:700,color:on?themeColor:G[700],overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap" }}>{sc.label}</span>
              {secBadge(sc, false)}
            </button>
          );
        })}
      </nav>
    );
  }

  // 업로드 액션
  async function doPreview(uploadId) {
    try { var data = await api.portalPreview(projForUpload(uploadId), uploadId); var a=document.createElement("a");a.href=data.url;a.target="_blank";a.rel="noopener";document.body.appendChild(a);a.click();document.body.removeChild(a); } catch(e) { showToast("오류: "+e.message); } finally { setUploading(false); }
  }

  async function doUpload(itemId, files) {
    if (uploading) return;
    var fileCount = files.length;
    setUploading(true);
    var submitName = portalName.trim() || "고객";
    try {
      await api.portalUpload(projForItem(itemId), itemId, submitName, Array.from(files));
      await loadPortal(d.id);
      showToast(fileCount + "개 파일 제출 완료");
    } catch(e) { showToast("업로드 실패: "+e.message); } finally { setUploading(false); }
  }

  async function doText(itemId, directText) {
    var text = directText || textInputs[itemId];
    if (!text || !text.trim()) return;
    var submitName = portalName.trim() || "고객";
    try {
      await api.portalText(projForItem(itemId), itemId, submitName, text);
      if(!directText) setTextInputs(function(prev) { var n = Object.assign({}, prev); delete n[itemId]; return n; });
      await loadPortal(d.id);
      showToast("제출 완료");
    } catch(e) { showToast("제출 실패: "+e.message); }
  }

  async function doDelete(uploadId) {
    try {
      await api.portalDelete(projForUpload(uploadId), uploadId);
      await loadPortal(d.id);
      showToast("삭제됨");
    } catch(e) { showToast("삭제 실패: "+e.message); }
  }

  // 컨테이너 스타일
  var containerS = {
    maxWidth: secMulti && secWide ? 1000 : (pMob ? 560 : 680),
    margin: "0 auto",
    padding: pMob ? "16px 16px 80px" : "24px 28px 80px",
    fontFamily:"'Pretendard','Apple SD Gothic Neo',system-ui,sans-serif",
  };

  // 아이템 카드 렌더
  function renderItemCard(item, iu, section) {
    var pend = iu.filter(function(u){return u.status==="pending";});
    var app = iu.filter(function(u){return u.status==="approved";});
    var rej = iu.filter(function(u){return u.status==="rejected";});
    var canUpload = section === "need" || section === "rejected" || (section === "pending" && iu.length < 10);
    var uploadRemain = 10 - iu.length;

    return (
      <div key={item.id}
            onDragOver={item.type==="file"&&canUpload?function(e){e.preventDefault();e.stopPropagation();e.currentTarget.style.background=themeColor+"08";e.currentTarget.style.border="2px dashed "+themeColor;}:undefined}
            onDragLeave={item.type==="file"&&canUpload?function(e){e.currentTarget.style.background="#fff";e.currentTarget.style.border="1px solid "+G[200];}:undefined}
            onDrop={item.type==="file"&&canUpload?function(e){e.preventDefault();e.stopPropagation();e.currentTarget.style.background="#fff";e.currentTarget.style.border="1px solid "+G[200];if(e.dataTransfer.files.length>0)doUpload(item.id,e.dataTransfer.files);}:undefined}
            style={{ background:"#fff",borderRadius:12,border:"1px solid "+G[200],padding:pMob?"14px":"16px 18px",marginBottom:10,transition:"border .15s, background .15s" }}>
        {/* 항목 헤더 */}
        <div style={{ display:"flex",alignItems:"center",gap:8,marginBottom:iu.length>0||canUpload?10:0 }}>
          <span style={{ fontSize:pMob?13:14,fontWeight:600,color:G[900],flex:1 }}>{item.label}</span>
          {item.required && <span style={{ fontSize:9,color:themeColor,fontWeight:700,background:themeColor+"15",padding:"1px 6px",borderRadius:4 }}>필수</span>}
          {item.sensitive && <span style={{ fontSize:9,color:"#D97706",fontWeight:700,background:"#FFFBEB",padding:"1px 6px",borderRadius:4 }}>보안정보</span>}
        </div>

        {/* 설명 */}
        {item.description && <p style={{ fontSize:12,color:G[500],margin:"0 0 8px",lineHeight:1.5,whiteSpace:"pre-wrap" }}>{item.description}</p>}





        {/* 가이드 참조 */}
        {item.guides && item.guides.length > 0 && section !== "done" && pend.length === 0 && (
          <div style={{ marginBottom:8 }}>
            {item.guides.map(function(g,gi) {
              return (
                <a key={gi} href={g.type==="link"?(g.url&&g.url.indexOf("http")===0?g.url:"https://"+g.url):"#"} target={g.type==="link"?"_blank":undefined}
                  onClick={g.type==="file" ? async function(e) {
                    e.preventDefault();
                    try { var data = await api.getPortalGuideDownloadUrl(item.projectId || d.id, g.id); if(data&&data.url){window.open(data.url,"_blank");}else{showToast("파일이 등록되지 않은 가이드입니다");} } catch(err) { showToast("가이드 파일 없음: "+(err.message||"서버 오류")); }
                  } : undefined}
                  style={{ display:"inline-flex",alignItems:"center",gap:4,fontSize:11,color:themeColor,textDecoration:"none",marginRight:12 }}>
                  <Svg d={g.type==="link"?iLink:iFile} s={12} c={themeColor} />
                  {g.label || g.fileName || "참조"}
                </a>
              );
            })}
          </div>
        )}

        {/* 민감 안내 */}

        {/* 제출물 목록 */}
        {iu.map(function(u) {
          var mins = minsLeft(u.createdAt || u.created_at);
          var canDel = u.status === "pending" && mins > 0;
          var isSensitive = item.sensitive;
          return (
            <div key={u.id} style={{ marginBottom:4 }}><div style={{ display:"flex",alignItems:"center",gap:8,padding:"6px 8px",background:u.status==="approved"?OKLt:u.status==="rejected"?ELt:WLt,borderRadius:6,flexWrap:pMob?"wrap":"nowrap" }}>
              <Svg d={u.type==="file"?iFile:iText} s={13} c={u.status==="approved"?OK:u.status==="rejected"?E:W} />
              <span style={{ flex:1,fontSize:12,color:G[700],minWidth:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap" }}>
                {isSensitive ? <span style={{ color:G[400],fontStyle:"italic" }}>*** (보안 항목)</span> : u.type==="file" ? <span onClick={function(e){e.stopPropagation();doPreview(u.id);}} style={{cursor:"pointer",textDecoration:"underline",color:themeColor}}>{iu.length > 1 ? (u.fileName || u.file_name || (item.label + "_" + d.name)) : (item.label + "_" + d.name)}</span> : (u.text ? u.text.substring(0,40) : "텍스트 제출됨")}
              </span>
              {u.type==="file" && !isSensitive && <span style={{ fontSize:10,color:G[400] }}>{u.fileSizeDisplay || ""}</span>}
              <span style={{ fontSize:10,color:u.status==="approved"?OK:u.status==="rejected"?E:W,fontWeight:600 }}>
                {u.status==="approved"?"\u2713 승인":u.status==="rejected"?"반려":"검토 대기"}
              </span>
              {fromAdmin && u.status==="pending" && <button disabled={actionLoading} onClick={function(e){e.stopPropagation();doAdminApprove(u.id);}} style={{ padding:"3px 8px",borderRadius:5,border:"1px solid "+OK,background:OKLt,color:OK,fontSize:9,fontWeight:600,cursor:"pointer",whiteSpace:"nowrap" }}>승인</button>}
              {fromAdmin && u.status==="pending" && <button disabled={actionLoading} onClick={function(e){e.stopPropagation();doAdminReject(u.id);}} style={{ padding:"3px 8px",borderRadius:5,border:"1px solid "+E,background:ELt,color:E,fontSize:9,fontWeight:600,cursor:"pointer",whiteSpace:"nowrap" }}>반려</button>}
              {canDel && (
                pMob ?
                  <button onClick={function(){doDelete(u.id);}} style={{ padding:"4px 10px",borderRadius:6,border:"1px solid #FECACA",background:ELt,color:E,fontSize:11,cursor:"pointer" }}>삭제 ({mins}분)</button> :
                  <button onClick={function(){doDelete(u.id);}} style={{ background:"none",border:"none",color:E,fontSize:10,textDecoration:"underline",cursor:"pointer" }}>삭제({mins}분)</button>
              )}
            </div></div>
          );
        })}
        {/* 반려 사유 (동일 사유 그룹핑) */}
        {(function() {
          var rejU = iu.filter(function(u){return u.status==="rejected";}); var reasons = [];
          rejU.forEach(function(u){ var r = u.reject_reason || u.rejectReason; if (r && reasons.indexOf(r) === -1) reasons.push(r); });
          return reasons.map(function(reason, ri) {
            return <div key={"pr"+ri} style={{ display:"flex",gap:6,paddingLeft:10,marginTop:2 }}><span style={{ color:"#D1D5DB",fontSize:14,lineHeight:1 }}>└</span><span style={{ fontSize:12,color:"#DC2626" }}>반려 사유: {reason}</span></div>;
          });
        })()}

        {/* 관리자 일괄 승인/반려 (2개 이상 대기일 때만) */}
        {fromAdmin && pend.length >= 2 && (
          <div style={{ display:"flex",gap:6,marginTop:6 }}>
            <button disabled={actionLoading} onClick={function(){doAdminBatchApprove(pend.map(function(u){return u.id;}));}} style={{ padding:"5px 12px",borderRadius:6,border:"none",background:OK,color:"#fff",fontSize:11,fontWeight:600,cursor:"pointer" }}>일괄 승인 ({pend.length}건)</button>
            <button disabled={actionLoading} onClick={function(){doAdminBatchReject(pend.map(function(u){return u.id;}));}} style={{ padding:"5px 12px",borderRadius:6,border:"none",background:E,color:"#fff",fontSize:11,fontWeight:600,cursor:"pointer" }}>일괄 반려</button>
          </div>
        )}

        {/* 업로드 버튼 */}
        {canUpload && item.type === "file" && (
          <div style={{ marginTop:6 }}
            onDragOver={function(e){e.preventDefault();e.stopPropagation();e.currentTarget.style.background=themeColor+"15";e.currentTarget.style.border="2px dashed "+themeColor;}}
            onDragLeave={function(e){e.currentTarget.style.background="";e.currentTarget.style.border="";}}
            onDrop={function(e){e.preventDefault();e.stopPropagation();e.currentTarget.style.background="";e.currentTarget.style.border="";if(e.dataTransfer.files.length>0)doUpload(item.id,e.dataTransfer.files);}}>
            <input type="file" multiple ref={function(el){fileRefs.current[item.id]=el;}} style={{ display:"none" }}
              onChange={function(e){ if(e.target.files.length>0) doUpload(item.id,e.target.files); e.target.value=""; }} />
            <button onClick={function(){if(fileRefs.current[item.id])fileRefs.current[item.id].click();}}
              style={{ width:pMob?"100%":"auto",padding:pMob?"12px 16px":"8px 14px",borderRadius:8,border:"1.5px solid "+themeColor,background:themeColor+"10",color:themeColor,fontSize:pMob?14:12,fontWeight:600,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:6,minHeight:pMob?44:"auto" }}>
              <Svg d={iUpload} s={14} c={themeColor} />
              {uploading ? "업로드 중..." : pend.length > 0 ? "추가 제출" : "파일 선택 및 제출"}
            </button>
          </div>
        )}

        {/* 텍스트 입력 */}
        {canUpload && item.type === "radio" && (item.options||[]).length > 0 && (
          <div style={{ marginTop:6 }}>
            {(item.options||[]).map(function(opt,oi){
              var selected = radioInputs[item.id] === opt;
              return <label key={oi} style={{ display:"flex",alignItems:"center",gap:8,padding:"8px 12px",marginBottom:4,borderRadius:8,border:selected?"1.5px solid "+themeColor:"1px solid "+G[200],background:selected?themeColor+"08":"#fff",cursor:"pointer",transition:"all .15s" }}
                onClick={function(){var id=item.id;setRadioInputs(function(p){var n=Object.assign({},p);n[id]=opt;return n;});}}>
                <span style={{ width:18,height:18,borderRadius:"50%",border:selected?"5px solid "+themeColor:"2px solid "+G[300],background:"#fff",boxSizing:"border-box",flexShrink:0 }}></span>
                <span style={{ fontSize:pMob?15:13,color:G[700] }}>{opt}</span>
              </label>;
            })}
            {radioInputs[item.id] && <button onClick={function(){doText(item.id,radioInputs[item.id]);var id=item.id;setRadioInputs(function(p){var n=Object.assign({},p);delete n[id];return n;});}}
              style={{ marginTop:4,padding:pMob?"12px 16px":"8px 14px",borderRadius:8,border:"none",background:themeColor,color:"#fff",fontSize:pMob?14:12,fontWeight:600,cursor:"pointer",minHeight:pMob?44:"auto" }}>
              제출
            </button>}
          </div>
        )}
        {canUpload && item.type === "checkbox" && (item.options||[]).length > 0 && (
          <div style={{ marginTop:6 }}>
            {(item.options||[]).map(function(opt,oi){
              var checked = ((checkInputs[item.id])||[]).indexOf(opt) >= 0;
              return <label key={oi} style={{ display:"flex",alignItems:"center",gap:8,padding:"8px 12px",marginBottom:4,borderRadius:8,border:checked?"1.5px solid "+themeColor:"1px solid "+G[200],background:checked?themeColor+"08":"#fff",cursor:"pointer",transition:"all .15s" }}
                onClick={function(){var id=item.id;setCheckInputs(function(p){var n=Object.assign({},p);var arr=(n[id]||[]).slice();var idx=arr.indexOf(opt);if(idx>=0)arr.splice(idx,1);else arr.push(opt);n[id]=arr;return n;});}}>
                <span style={{ width:18,height:18,borderRadius:4,border:checked?"none":"2px solid "+G[300],background:checked?themeColor:"#fff",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,boxSizing:"border-box" }}>{checked && <span style={{ color:"#fff",fontSize:12,fontWeight:700 }}>✓</span>}</span>
                <span style={{ fontSize:pMob?15:13,color:G[700] }}>{opt}</span>
              </label>;
            })}
            {(checkInputs[item.id]||[]).length > 0 && <button onClick={function(){var val=(checkInputs[item.id]||[]).join(", ");doText(item.id,val);var id=item.id;setCheckInputs(function(p){var n=Object.assign({},p);delete n[id];return n;});}}
              style={{ marginTop:4,padding:pMob?"12px 16px":"8px 14px",borderRadius:8,border:"none",background:themeColor,color:"#fff",fontSize:pMob?14:12,fontWeight:600,cursor:"pointer",minHeight:pMob?44:"auto" }}>
              제출 ({(checkInputs[item.id]||[]).length}개 선택)
            </button>}
          </div>
        )}
        {canUpload && (item.type === "text" || item.type === "text_long") && (
          <div style={{ marginTop:6, display:"flex", flexDirection:pMob?"column":"row", gap:6 }}>
            {item.type === "text_long" ?
              <textarea value={textInputs[item.id]||""} onChange={function(e){var id=item.id;setTextInputs(function(p){var n=Object.assign({},p);n[id]=e.target.value;return n;});}} rows={3} placeholder="내용을 입력하세요..." style={{ flex:1,padding:"10px 12px",border:"1.5px solid "+G[200],borderRadius:8,fontSize:pMob?16:14,outline:"none",resize:"vertical",boxSizing:"border-box" }} /> :
              <input value={textInputs[item.id]||""} onChange={function(e){var id=item.id;setTextInputs(function(p){var n=Object.assign({},p);n[id]=e.target.value;return n;});}} onKeyDown={function(e){if(e.key==="Enter")doText(item.id);}} placeholder="입력하세요..." style={{ flex:1,padding:"10px 12px",border:"1.5px solid "+G[200],borderRadius:8,fontSize:pMob?16:14,outline:"none",boxSizing:"border-box" }} />
            }
            <button onClick={function(){doText(item.id);}} disabled={!(textInputs[item.id]||"").trim()}
              style={{ padding:pMob?"12px 16px":"8px 14px",borderRadius:8,border:"none",background:(textInputs[item.id]||"").trim()?themeColor:G[300],color:"#fff",fontSize:pMob?14:12,fontWeight:600,cursor:(textInputs[item.id]||"").trim()?"pointer":"not-allowed",minHeight:pMob?44:"auto" }}>
              제출
            </button>
          </div>
        )}
      </div>
    );
  }

  return (
    <div style={{ minHeight:"100vh",background:G[50] }}>
      {toast && <div style={{ position:"fixed",bottom:30,left:"50%",transform:"translateX(-50%)",background:"#059669",color:"#fff",padding:"12px 24px",borderRadius:12,fontSize:14,fontWeight:600,zIndex:10000,boxShadow:"0 4px 16px rgba(0,0,0,.2)",display:"flex",alignItems:"center",gap:8 }}>✓ {toast}</div>}
      <div style={containerS}>
        {/* 우측 상단 로고 */}
        {brand.logo && <div style={{ display:"flex",justifyContent:"flex-end",marginBottom:8 }}><img src={brand.logo} alt={brand.name||""} style={{ height:brand.brand==="atv"?36:brand.brand==="law"?40:24,maxWidth:brand.brand==="atv"||brand.brand==="law"?"min(178px,44vw)":"min(140px,34vw)",objectFit:"contain" }} /></div>}

        {/* 관리자 뒤로가기 */}
        {fromAdmin && window.location.pathname.indexOf("/portal/")!==0 && <button onClick={function(){setScreen("detail");}} style={{ background:"none",border:"none",cursor:"pointer",display:"flex",alignItems:"center",gap:5,color:G[500],fontSize:13,padding:0,marginBottom:12 }}>
          <Svg d={iBack} s={15} c={G[500]} /> 관리자로 돌아가기
        </button>}
        {/* 고객 페이지(/c/…)에서 「자료 올리기」로 왔으면 돌아가는 길 (2026-10-12 검수: 올린 뒤 진행 안내로 돌아올 길이 없었음) */}
        {(() => { let back = ''; try { back = sessionStorage.getItem('roum-client-back') || ''; } catch (e) { back = ''; } return /^\/c\/[0-9a-f]{32}$/.test(back) ? (
          <a href={back} style={{ display:"inline-flex",alignItems:"center",gap:5,minHeight:44,color:G[700],fontSize:15,fontWeight:600,textDecoration:"none",marginBottom:8 }}>
            <Svg d={iBack} s={16} c={G[500]} /> 진행 안내로 돌아가기
          </a>
        ) : null; })()}

        {/* 헤더 */}
        <div style={{ textAlign:"center",marginBottom:24 }}>
          
          {brand.name && <p style={{ fontSize:12,color:G[400],marginBottom:4 }}>{brand.name}</p>}
          <h1 style={{ fontSize:pMob?18:20,fontWeight:700,color:G[900],margin:"0 0 4px" }}>{d.name}</h1>
          <p style={{ fontSize:13,color:G[500] }}>{d.project}</p>
        </div>

        {/* 제출자 선택 (숨김 - 나중에 복원 가능) */}
        {false && !portalName && !allDone && (
          <div style={{ background:"#fff",borderRadius:12,border:"1px solid "+G[200],padding:pMob?"16px":"20px",marginBottom:20 }}>
            <p style={{ fontSize:13,fontWeight:600,color:G[700],marginBottom:12 }}>누가 제출하시나요?</p>
            <div style={{ display:"flex",flexWrap:"wrap",gap:8 }}>
              {(d.submitters||[]).map(function(s) {
                return <button key={s.id} onClick={function(){setPortalName(removeTitleFromName(s.name));}} style={{ padding:"10px 16px",borderRadius:8,border:"1.5px solid "+G[300],background:"#fff",color:G[700],fontSize:13,fontWeight:600,cursor:"pointer" }}>{removeTitleFromName(s.name)}</button>;
              })}
              {!portalCustom && <button onClick={function(){setPortalCustom(true);}} style={{ padding:"10px 16px",borderRadius:8,border:"1.5px solid "+G[200],background:"#fff",color:G[500],fontSize:13,cursor:"pointer" }}>직접 입력</button>}
            </div>
            {portalCustom && (
              <div style={{ display:"flex",gap:8,marginTop:10 }}>
                <input placeholder="이름을 입력하세요" style={{ flex:1,padding:"10px 12px",border:"1.5px solid "+G[200],borderRadius:8,fontSize:pMob?16:14,outline:"none",boxSizing:"border-box" }}
                  onKeyDown={function(e){if(e.key==="Enter"&&e.target.value.trim())setPortalName(e.target.value.trim());}} id="portal-custom-name" />
                <button onClick={function(){var el=document.getElementById("portal-custom-name");if(el&&el.value.trim())setPortalName(el.value.trim());}} style={{ padding:"10px 16px",borderRadius:8,border:"none",background:themeColor,color:"#fff",fontSize:13,fontWeight:600,cursor:"pointer" }}>확인</button>
              </div>
            )}
          </div>
        )}

        {/* 제출자 표시 (숨김 - 나중에 복원 가능) */}
        {false && portalName && (
          <div style={{ display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16,padding:"8px 14px",background:themeColor+"10",borderRadius:8 }}>
            <span style={{ fontSize:13,color:themeColor,fontWeight:600 }}>👤 {portalName}</span>
            <button onClick={function(){setPortalName("");setPortalCustom(false);}} style={{ background:"none",border:"none",color:G[400],fontSize:11,cursor:"pointer",textDecoration:"underline" }}>변경</button>
          </div>
        )}




        {secMulti && !secWide && renderSecTabs()}
        <div ref={secTopRef} style={secMulti && secWide ? { display:"flex",alignItems:"flex-start",gap:24 } : undefined}>
        {secMulti && secWide && renderSecTree()}
        <div style={{ flex:1,minWidth:0 }}>
        {/* 프로젝트 참고자료 - 보조 링크 */}
        {d.projectGuides && d.projectGuides.length > 0 && <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap",justifyContent:"flex-end",marginBottom:10}}>
          <span style={{fontSize:11,color:G[400],flexShrink:0}}>참고자료</span>
          {d.projectGuides.map(function(g,gi){
            return <span key={gi} onClick={g.type==="link"?function(){var url=g.url||"";if(url&&url.indexOf("http")!==0)url="https://"+url;window.open(url,"_blank");}:g.type==="file"?async function(){try{var data=await api.getPortalProjectGuideDownloadUrl(d.id,g.id);window.open(data.url,"_blank");}catch(err){showToast("다운로드 오류");}}:undefined}
              style={{fontSize:11,color:themeColor,cursor:"pointer",textDecoration:"underline",textUnderlineOffset:2}}>
              {g.type==="link"?"🔗":"📎"} {g.label||"참조"}
            </span>;
          })}
        </div>}

        {/* 섹션별 렌더링 — subject 섹션(개인/법인) 있으면 주체별로 묶고, 없으면 상태별 평면(타 모듈 무영향) */}
        {(function() {
          var statusGroups = [
            { key:"need", title:"📋 제출해 주세요", items:sections.need, color:themeColor },
            { key:"rejected", title:"⚠️ 재제출이 필요합니다", items:sections.rejected, color:E },
            { key:"done", title:"✅ 승인 완료", items:sections.done, color:OK },
            { key:"pending", title:"⏳ 검토 대기 중", items:sections.pending, color:W },
          ];
          function renderGroups(filterFn, showPendingBanner) {
            return statusGroups.map(function(sec) {
              var entries = filterFn ? sec.items.filter(filterFn) : sec.items;
              if (entries.length === 0) return null;
              var isPending = sec.key === "pending";
              return (
                <div key={sec.key} style={{ marginBottom:20 }}>
                  <h3 style={{ fontSize:pMob?14:15,fontWeight:700,color:sec.color,margin:"0 0 10px",display:"flex",alignItems:"center",gap:6 }}>
                    {sec.title} <span style={{ fontSize:11,fontWeight:500,color:G[400] }}>({entries.length})</span>
                  </h3>
                  {isPending && showPendingBanner && <div style={{ padding:"10px 14px", background:"#FFFBEB", border:"1px solid #FDE68A", borderRadius:8, marginBottom:10, fontSize:12, color:"#92400E", lineHeight:1.5 }}>⏳ 제출이 완료되었어요! 담당자가 검토 중입니다. 결과가 나오면 알려드릴게요.</div>}
                  {entries.map(function(entry) {
                    return renderItemCard(entry.item, entry.uploads, sec.key);
                  })}
                  <div style={{ borderBottom:"1px solid "+G[200], marginTop:16 }}></div>
                </div>
              );
            });
          }
          var hasSubjects = items.some(function(it){ return !!it.section; });
          if (!hasSubjects) return renderGroups(null, true);
          const curSec = portalSecs.find(function(sc) { return sc.key === curSecKey; }) || portalSecs[0];
          if (!curSec) return null;
          const curIdx = portalSecs.indexOf(curSec);
          const allTally = portalSecs.reduce(function(acc, sc) {
            acc.left += sc.left; acc.reqLeft += sc.reqLeft; acc.pending += sc.pending; return acc;
          }, { left: 0, reqLeft: 0, pending: 0 });
          let overallMsg = "";
          if (allTally.left > 0) {
            overallMsg = "제출할 자료가 " + allTally.left + "건 남았어요"
              + (allTally.reqLeft > 0 && allTally.reqLeft < allTally.left ? " (필수 " + allTally.reqLeft + "건)" : "")
              + (portalSecs.length > 1 ? " · " + portalSecs.length + "개 묶음을 모두 확인해 주세요" : " · 항목별로 파일을 올리거나 내용을 입력해 주세요");
          } else if (allTally.pending > 0) {
            overallMsg = "모든 자료를 제출했어요! 담당자가 검토 중입니다.";
          } else {
            overallMsg = "모든 자료 확인이 끝났어요. 협조해 주셔서 감사합니다.";
          }
          return (
            <>
              <div key="__overall" style={{ display:"flex",alignItems:"center",gap:10,padding:pMob?"12px 14px":"14px 16px",borderRadius:10,marginBottom:16,
                  background: allTally.left > 0 ? "#FFFBEB" : OK + "12",
                  border: "1px solid " + (allTally.left > 0 ? "#FDE68A" : OK + "40") }}>
                <span style={{ fontSize:pMob?18:20,lineHeight:1 }}>{allTally.left > 0 ? "📋" : "✅"}</span>
                <span style={{ fontSize:pMob?13:14,fontWeight:700,lineHeight:1.5,color: allTally.left > 0 ? "#92400E" : OK }}>{overallMsg}</span>
              </div>
              <div key={curSec.key} style={{ marginBottom:8 }}>
                <div style={{ display:"flex",alignItems:"center",gap:8,padding:pMob?"12px 14px":"13px 16px",background:themeColor+"12",border:"1px solid "+themeColor+"33",borderRadius:10,marginBottom:14 }}>
                  <span style={{ width:24,height:24,borderRadius:7,background:themeColor,color:"#fff",fontSize:13,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0 }}>{curIdx+1}</span>
                  <span style={{ fontSize:pMob?14:15,fontWeight:700,color:G[900] }}>{curSec.label}</span>
                  <span style={{ flex:1 }} />
                  {curSec.left > 0
                    ? <span style={{ fontSize:11,fontWeight:700,color:"#B45309",background:"#FEF3C7",border:"1px solid #FDE68A",padding:"3px 9px",borderRadius:20,whiteSpace:"nowrap" }}>제출 필요 {curSec.left}건</span>
                    : <span style={{ fontSize:11,fontWeight:700,color:OK,background:OK+"18",padding:"3px 9px",borderRadius:20,whiteSpace:"nowrap" }}>✓ 제출 완료</span>}
                </div>
                {renderGroups(function(e){ return (e.item.section || BASE_SEC) === curSec.key; }, false)}
              </div>
            </>
          );
        })()}
        </div>
        </div>
      </div>
    </div>
  );
}
